import axiosapi from "./axiosAPI";

// Get All Countries
export const getAllCountries = async (
    setCountries,
    setFetcherror,
    callback
) => {
	try{
		const res =await axiosapi.get("/countries");
        setCountries(res.data.data ? res.data.data : {});
        if(callback){
            callback(res.data.data, "error");
        }
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            setFetcherror("Error: Could Not Fetch Countries");
            if(callback){
                callback("error", true);
            }
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Countries");
            if(callback){
                callback("error", true);
            }
		}
		
	}
	
};



// Get One Country
export const getOneCountry = async (
    pkid,
    setFetcherror,  
    setCountry
    
)=>{
	try{
		const res =await axiosapi.get(`/countries/${pkid}`);
        setCountry(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Country");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Country");
		}
		
	}
	
};


// Create New Country
export const createCountry = async (
    countryName,
    setCountryName,
    countryCode,
    setCountryCode,
    setFetcherror,
    handleAllToasts,
    setCountries

) => {

    if (!countryName || !countryCode ) {
        handleAllToasts(2, "No Country Provided"); 
            return; 
        }

    const PushItem = {
        name: countryName,
        code: countryCode
        };

    try{
        await axiosapi.post("/countries/",PushItem );
        setCountryName("");
        setCountryCode("");
        handleAllToasts(1, "Country Created Successfully");
        getAllCountries(setCountries,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Country");
            handleAllToasts(2, "Could Not update The Country");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Country");
            handleAllToasts(2, "Could Not update The Country");
            
        }
        
    }
    
}


// Edit Existing Country

export const editCountry = async (
    countrypkid,
    countryName,
    setCountryName,
    countryCode,
    setCountryCode,
    setFetcherror,
    handleAllToasts,
    setCountries
              
        ) => {

            if (!countryName || !countryCode) {
                handleAllToasts(2, "No Country Name Provided or Code Provided"); 
                    return;  
                }

            const PushItem = {

                    id:countrypkid,
                    name: countryName,
                    code:countryCode
                };

            try{
                await axiosapi.patch("/countries/",PushItem );
                setCountryName("");
                setCountryCode("");
                handleAllToasts(1, "Country Updated Successfully");
                getAllCountries(setCountries,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Country");
                    handleAllToasts(2, "Could Not Update Country");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Country");
                    handleAllToasts(2, "Could Not Update Country");
                    
                }
                
            }
            
};



// Delete Existing Country.

export const deleteCountry = async (
    countrypkid,
    setCountries,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/countries/${countrypkid}`);
        let finalData = res.data.message;
        getAllCountries(setCountries, setFetcherror);
        handleAllToasts(1, "Country Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Country");
            handleAllToasts(2,"Error: Could Not Delete Country");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Country");
            handleAllToasts(2,"Error: Could Not Delete Country");
		}
		
	}
	
};